export const NOTES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];

export const INFLUENCE_WEIGHTS = {
    GLOBAL: 0.6,    // The Conductor
    NARRATIVE: 0.4, // The Scene
    LOCAL: 0.2,     // The Player (Genre)
    TRAIT: 0.1      // Dynamic Modifiers
};
